var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityTable',{attrs:{"entity-type":_vm.entityType,"headers":_vm.state.headers,"filters-dropdown":_vm.filtersDropdown},scopedSlots:_vm._u([{key:"thumbImage",fn:function(ref){
var item = ref.item;
return [_c('img',{staticClass:"image-preview",attrs:{"src":item.thumbImage.url,"alt":item.thumbImage.fileName}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }